// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_footerContainer__--Xv7{
    border-top: 2px solid var(--gray-5);
    width: 100%;
    height: 100px;
}

.footer_footerItems__a-MBu{
    display: flex;
    align-items: center;
    padding: 20px;
    
    justify-content: center;
}

.footer_divisionFooter__jEHD4{
    width: 0;
    height: 80px;
    margin-left: 4vw;
    margin-right: 4vw;
    border: 1px solid #E9ECEF;
}

.footer_footerItemTelefone__IhqnY{
    margin:10px;
}

.footer_footerItemTelefoneText__F3xHW{
    font-size: 24px;
    padding-bottom:10px;
    text-align: left;
    font-family: var(--goldplay-regular);
}

.footer_footerItemTelefoneContato__Du4Gh{
    display: inline-flex;
    padding: 0 5px 5px 0;
    gap: 5px;
}

.footer_footerItemTelefoneContatoText__97PRm{
    font-family:var(--goldplay-regular);
    font-size: 20px;
    line-height: 26px;
    color: var(--gray-11);
    align-self: flex-start;
}

.footer_footerItemTextDays__SfRZU{
    font-family:var(--goldplay-regular);
    color:#69737D;
    font-size: 18px;
    font-weight: 400;
    line-height: 20px;
}

.footer_footerItemSociais__Wp0tY{
    margin-bottom: 30px;
}

.footer_footerItemSociaisText__S8kVF{
    font-size: 24px;
    font-family: var(--goldplay-regular);
    
}

.footer_footerItemSociaisText__S8kVF span{
    font-family: var(--goldplay-semibold-alt);
    color:var(--secundary);
}

.footer_footerItemSociais__Wp0tY a{
    width: 40px;
    height: 40px;
    display: inline-flex;
    margin:10px 0 0 10px;
} `, "",{"version":3,"sources":["webpack://./src/components/footer/footer.module.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;;IAEb,uBAAuB;AAC3B;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,QAAQ;AACZ;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oCAAoC;;AAExC;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;AACxB","sourcesContent":[".footerContainer{\n    border-top: 2px solid var(--gray-5);\n    width: 100%;\n    height: 100px;\n}\n\n.footerItems{\n    display: flex;\n    align-items: center;\n    padding: 20px;\n    \n    justify-content: center;\n}\n\n.divisionFooter{\n    width: 0;\n    height: 80px;\n    margin-left: 4vw;\n    margin-right: 4vw;\n    border: 1px solid #E9ECEF;\n}\n\n.footerItemTelefone{\n    margin:10px;\n}\n\n.footerItemTelefoneText{\n    font-size: 24px;\n    padding-bottom:10px;\n    text-align: left;\n    font-family: var(--goldplay-regular);\n}\n\n.footerItemTelefoneContato{\n    display: inline-flex;\n    padding: 0 5px 5px 0;\n    gap: 5px;\n}\n\n.footerItemTelefoneContatoText{\n    font-family:var(--goldplay-regular);\n    font-size: 20px;\n    line-height: 26px;\n    color: var(--gray-11);\n    align-self: flex-start;\n}\n\n.footerItemTextDays{\n    font-family:var(--goldplay-regular);\n    color:#69737D;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 20px;\n}\n\n.footerItemSociais{\n    margin-bottom: 30px;\n}\n\n.footerItemSociaisText{\n    font-size: 24px;\n    font-family: var(--goldplay-regular);\n    \n}\n\n.footerItemSociaisText span{\n    font-family: var(--goldplay-semibold-alt);\n    color:var(--secundary);\n}\n\n.footerItemSociais a{\n    width: 40px;\n    height: 40px;\n    display: inline-flex;\n    margin:10px 0 0 10px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerContainer": `footer_footerContainer__--Xv7`,
	"footerItems": `footer_footerItems__a-MBu`,
	"divisionFooter": `footer_divisionFooter__jEHD4`,
	"footerItemTelefone": `footer_footerItemTelefone__IhqnY`,
	"footerItemTelefoneText": `footer_footerItemTelefoneText__F3xHW`,
	"footerItemTelefoneContato": `footer_footerItemTelefoneContato__Du4Gh`,
	"footerItemTelefoneContatoText": `footer_footerItemTelefoneContatoText__97PRm`,
	"footerItemTextDays": `footer_footerItemTextDays__SfRZU`,
	"footerItemSociais": `footer_footerItemSociais__Wp0tY`,
	"footerItemSociaisText": `footer_footerItemSociaisText__S8kVF`
};
export default ___CSS_LOADER_EXPORT___;
